export default __webpack_public_path__ + "static/media/Social Links.e5313117.svg";